<template>
  <!-- 
  1.화면ID    : MSM_SA_002
  2.화면명    : 영업기회 알람 조회/수정
  3.작성자    : 윤태영 차장
    추가자    : 
  4.화면설명  : 영업관리 알람조회 화면이다. 
  * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
  -->

  <div class="content-wrap">
    <div class="search-wrap">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
              <ElLabel name="영업기회ID">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.searchParams.sales_id" @inputKeyupEnter="getDataList"/>
                </template>
              </ElLabel>

          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
              <ElLabel name="End User">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.searchParams.end_user_nm" @update:modelValue="getNameMask" @inputKeyupEnter="getDataList"/>
                </template>
              </ElLabel>

          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
              <ElLabel name="매출처">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.searchParams.out_sales_nm" @update:modelValue="getNameMask" @inputKeyupEnter="getDataList"/>
                </template>
              </ElLabel>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <ElLabel name="Warranty End Date">
              <template #end="{id}">
                <div class="d-flex" :id="id">
                  <DatePicker :frmType="'YMD'" format="yyyy-MM-dd" @return="r => state.searchParams.start_dt = r"
                    :select-date="state.searchParams.start_dt" /> 
                    <span class="px-2 pt-1">~</span>
                  <DatePicker :frmType="'YMD'" format="yyyy-MM-dd" @return="r => state.searchParams.end_dt = r"
                    :select-date="state.searchParams.end_dt" />
                </div>
              </template>
            </ElLabel>
            
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="Stage">
              <template #end>
                <ElSelect v-model="state.PipelineList" :options="[{text: '선택하세요', value: 'null'}, ...state.sPipelineList]"/>
              </template>
            </ElLabel>
          </div>
        </div>
         <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="구분">
              <template #end>
                <ElSelect v-model="state.wpType" :options="state.wpTypeList"/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
    </div>
    <div class="search-detail-wrap"></div>

    <div class="text-end py-2">
      <ElButton type="search" @buttonClick="getDataList()">검색</ElButton>
    </div>

    <div class="d-flex justify-content-between">
      <div></div>
      <div class="table-btn-group">
        <ElButton type="excelDownload" @buttonClick="excelDown()">엑셀다운</ElButton>
      </div>
    </div>
    <!--그리드 영역-->
    <div class="table-responsive table-list">
      <DataTable
      :value="state.gridRowData" 
      paginator 
      :rows="20" 
      :rowsPerPageOptions="[10, 20, 50, 100, 200]"
      selectionMode="single"
      @rowSelect="onRowSelect"
      removableSort>
        <template #empty>
          <div class="center">데이터가 존재하지 않습니다.</div>
        </template>
        <Column>
          <template #header>
              <ElCheckbox v-model="allCheck"/>
          </template>
          <template #body="{ data }">
              <ElCheckbox 
              v-model="state.selectedRow" 
              :value="data"
              />
          </template>
        </Column>
        
        <Column v-for="(notice,index) of state.gridColumn" :key="index" :field="notice.field" :header="notice.headerName"
          sortable :style="notice.style">
          <template #body="{ data, field, index }">
            <span v-if="notice.field == 'outcome_sum'">{{ getOptionData(data.outcome_sum) }}</span>
            <span v-else-if="notice.field == 'number'">{{ index + 1 }}</span>
            <span v-else-if="notice.field == 'stage_nm'" :class="getOptionStyle(data.stage_cd)">{{ data.stage_nm
              }}</span>
            <span v-else-if="notice.field == 'sales_nm'" v-tooltip.bottom="data[field]">{{ getSummaryData(data[field]) }}</span>
            <div v-else-if="field == 'w_alarm_yn'">
                <span :class="getStageOptionStyle(data[field])">{{ data[field] }}</span>
            </div>
            <div 
              v-else-if="notice.field === 'end_user_nm' || notice.field === 'out_sales_nm'" 
              v-bind:title="data.end_user_nm"
              style="width: 110px;text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"
            >
            {{ data.end_user_nm }}
          </div>
            <span v-else>{{ data[field] }}</span>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>

  <ExcelManage v-show="false" ref="excelManageRef" />
</template>

<script setup>

import { reactive, ref, onBeforeMount, onMounted, computed } from 'vue'
import ExcelManage from '@/components/common/MCO_EX_001.vue';
import DatePicker from '@/components/common/DatePicker.vue';
import { useRouter } from "vue-router";
import common from '@/js/common';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import vueRouterCmn from '@/js/vueRouterCmn';

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { alarmList } from '@/api/alarm';
const excelManageRef = ref()
const router = useRouter();


// 기간설정 초기화 중 DatePicker에서 한달 후 값으로 입력받아 넣으니 달을 바꿔도 무조건 
// 그 다음달로 초기화 되어 end_dt에 대해서만 적용해 주기 위해 아래 값으로 대체함.
var dt = new Date()
var dtStr = dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 2)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2);

//수정권한으로 row클릭시 상세조회/수정페이지 이동 분기처리
const canUpdate = computed(()=>{
    return common.checkAccessAuth('M002M001M001')
})

onBeforeMount(async () => {
  //state.pageType = 'update' TODO
})

onMounted(() => {
  // state.searchParams.start_dt = common.dateFormat(dt)
  // state.searchParams.end_dt = dtStr;
  getDataList();
})

const allCheck = computed({
  get() {
    return state.gridRowData.length === state.selectedRow.length;
  },
  set(newValue) {
    state.selectedRow = newValue ? state.gridRowData.map((item) => { return item.index }) : [];
  }
})

const getDataList = async () => {

  var vPipelineList;

  if (state.PipelineList == "null") {
    vPipelineList = "";
  } else {
    vPipelineList = state.PipelineList;
  }

  let params = {
    sales_id: state.searchParams.sales_id,
    alarm_seq: state.searchParams.alarm_seq,
    end_user_nm: state.searchParams.end_user_nm,
    end_user_nm: state.searchParams.end_user_nm,
    out_sales_nm: state.searchParams.out_sales_nm,
    start_dt: state.searchParams.start_dt,
    end_dt: state.searchParams.end_dt,
    stage_cd: vPipelineList,
    wpType : state.wpType,
    page_count : 1,
    unit_count : 100000,
  }

  try {
    setIsLoading(true)
    const res = await alarmList(params)
    const detailSa = [...res.rtn].map((item,index)=>{
      item.index = index
      return item
    });
    state.gridRowData = detailSa
  } catch (err) {
    alert("조회 중 에러가 발생하였습니다.");
  } finally {
    setIsLoading(false)
  }
};

//변수 선언 영역 
const state = reactive({
  //컬럼 셋팅
  selectedRow: [],
  gridColumn: [
    { headerName: 'ID', field: "sales_id", style: { minWidth: "160px" } },
    { headerName: '영업기회명명', field: "sales_nm", style: { minWidth: "160px" }},
    { headerName: '단계', field: "stage_nm", style: { minWidth: "120px" } },
    { headerName: '매출처', field: "out_sales_nm"},
    { headerName: '금액', field: "outcome_sum", style: { textAlign : 'right',minWidth: "120px" } },
    { headerName: '매입처', field: "buy_cmp_nm"},
    { headerName: '상품', field: "prod_nm", style: { textAlign : 'center',  minWidth: "120px" } },
    // { headerName: '기회소유자', field: "out_sales_id", style: { minWidth: "120px" } },
    { headerName: '구분', field: "w_alarm_yn", style: { textAlign : 'center',minWidth: "140px" } },
    // { headerName: '지급일알람', field: "p_alarm_yn", style: { textAlign : 'center',minWidth: "130px" } },
  ],
  gridRowData: [],
  //PipeLise 리스트 
  sPipelineList: [
    { text: 'Pipeline', value: 'STG01' },
    { text: 'Upside', value: 'STG02' },
    { text: 'Commit', value: 'STG03' },
    { text: 'Won', value: 'STG04' },
    { text: 'Close', value: 'STG05' },
    { text: 'Omit', value: 'STG06' },
    { text: 'Lost', value: 'STG07' },
  ],
  wpTypeList:[
    { text: '선택하세요.', value: null },
    { text: 'Warranty', value: 'w' },
    { text: '지급일', value: 'p' },
  ],
  wpType:null,
  PipelineList: 'null',
  searchParams: {
    sales_id: '',
    end_user_nm: '',
    out_sales_nm: '',
    start_dt: '',
    end_dt: '',
    stage_cd: '',
    page_count: 1,
    unit_count: 100000,
  }
});


const getSummaryData = (item) => {
  let summaryData = item.length > 6 ? item.slice(0, 16) + " ..." : item;

  return summaryData
}

//특수문자
const getNameMask = (data) => {
  if (data != undefined && data != "") {
    if (state.searchParams.end_user_nm || state.searchParams.out_sales_nm) {
      state.searchParams.end_user_nm = common.checkSpecChar(state.searchParams.end_user_nm);
      state.searchParams.out_sales_nm = common.checkSpecChar(state.searchParams.out_sales_nm);
    }
  }
}

const getStageOptionStyle = (item) => {
    const stageValue = item
    let classNm = ''
    if (stageValue == '') {
        classNm = 'stage stage-pipeline';
    } else if (stageValue == '') {
        classNm = 'stage stage-upside';
    } else if (stageValue == '') {
        classNm = 'stage stage-commit';
    } else if (stageValue == '지급일') {
        classNm = 'stage stage-won';
    } else if (stageValue == 'Warranty') {
        classNm = 'stage stage-close';
    } else if (stageValue == '') {
        classNm = 'stage stage-omit';
    } else if (stageValue == '') {
        classNm = 'stage stage-lost';
    }
    return classNm
}


const getOptionData = (item) => {
  return common.checkNumberComma(item)
}

const getOptionStyle = (item) => {
  const stageValue = item
  let classNm = ''
  if (stageValue == 'STG01') {
    classNm = 'stage-pi';
  } else if (stageValue == 'STG02') {
    classNm = 'stage-up';
  } else if (stageValue == 'STG03') {
    classNm = 'stage-co';
  } else if (stageValue == 'STG04') {
    classNm = 'stage-cl';
  } else if (stageValue == 'STG05') {
    classNm = 'stage-om';
  } else if (stageValue == 'STG06') {
    classNm = 'stage-wo';
  } else if (stageValue == 'STG07') {
    classNm = 'stage-pu';
  }

  return classNm
}

const excelDown = () => {
  let fileNm = '영업기회 알람 리스트'
  let header = state.gridColumn
  let dataList = state.gridRowData
  if (state.selectedRow?.length > 0) {
    dataList = state.selectedRow
  }

  excelManageRef.value.excelDownload(fileNm, header, dataList)
}

const onRowSelect = (notice) => {
  if(canUpdate.value){
    vueRouterCmn.routerPush('MSM_SA_003', { alarm_seq: notice.data.alarm_seq})
  }else{
    vueRouterCmn.routerPush('MSM_SA_010', { alarm_seq: notice.data.alarm_seq})
  }
}

</script>